var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 170,
    viewBox: "0 0 132 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 168,
    rx: 3,
    stroke: "#D9E5F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 86H67V92H65V86H59V84H65V78H67V84H73V86Z",
    fill: "#D9E5F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolderIcon);
export default __webpack_public_path__ + "static/media/new-folder-icon.a46551ef18acfa8645b6409f41faf5e1.svg";
export { ForwardRef as ReactComponent };